import ResourceUtils from "../../utils/resource-utils"
import { LearningObject } from "../learningObject.model"

export class PremiumSectionTopic {
    public isLoadingResources = false // Managed by the service
    public visibleLearningObjects: LearningObject[] = []
    public titleForAutoscroll = ""
    public static resourcesPerRow = 4

    constructor(
        public id: string,
        public title: string,
        public resources: LearningObject[],
        public loadMoreLink: string,
        public resourceMediaTypes: { [mediaType: string]: number },
        public resourceCount: number
    ) {
        this.visibleLearningObjects = this.resources.slice(0, PremiumSectionTopic.resourcesPerRow)
        this.titleForAutoscroll = this.getAutoScrollableId(this.title)
    }

    public showMoreResources() {
        if (this.visibleLearningObjects.length < this.resourceCount) {
            this.visibleLearningObjects = this.resources.slice()
        }
    }

    public allResourcesLoaded(): boolean {
        return this.resources.length === this.resourceCount
    }

    public allResourcesVisible(): boolean {
        return this.visibleLearningObjects.length === this.resourceCount
    }

    public shouldShowLoadMore(): boolean {
        if (this.isLoadingResources) {
            return false
        }
        return !this.allResourcesVisible()
    }

    public shouldShowLoadLess(): boolean {
        if (this.isLoadingResources) {
            return false
        }
        return (
            this.allResourcesLoaded() &&
            this.visibleLearningObjects.length > PremiumSectionTopic.resourcesPerRow
        )
    }

    public addFromResponse(data) {
        ;(data.results || []).forEach((lo_data) => {
            this.resources.push(new LearningObject(lo_data))
        })
        this.loadMoreLink = data.next
    }

    public static fromData(data): PremiumSectionTopic {
        const resourcesData = data.resources || {}
        return new PremiumSectionTopic(
            data.id,
            data.title || "",
            (resourcesData.results || []).map((lo_data) => new LearningObject(lo_data)),
            resourcesData.next,
            data.resources_info,
            resourcesData.count
        )
    }

    public getResourceTypesDisplay(): string {
        return ResourceUtils.getMediaTypesDisplay(this.resourceMediaTypes)
    }

    public showLessResources() {
        this.visibleLearningObjects = this.resources.slice(0, PremiumSectionTopic.resourcesPerRow)
    }

    public getAutoScrollableId(elementId) {
        const regex = "/[^A-Za-z0-9-_]/g"
        return elementId.replace(eval(regex), "-")
    }
}
